import DefaultLayout from "./layouts/DefaultLayout";

function Admin() {
  return <DefaultLayout></DefaultLayout>;
}
export default Admin;
